import { ItemList } from '../../orm'

class AdminIncomingVoiceMessageList extends ItemList {
    getEntityKey() {
        return 'admin/incoming_voice_message'
    }
}

export const adminIncomingVoiceMessageList = new AdminIncomingVoiceMessageList('admin_incoming_voice_message__default')
